import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import {
    DETAIL_HEADER_HEIGHT,
    TOP_BAR_TOTAL_HEIGHT
} from '../../../runtime/Navigation/Menu/Menu.styles';

export const navigationPickerLineHeight = 50;

const baseStyles = {
    pickerWindow: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        width: 'auto',
        alignItems: Device.isTablet ? 'center' : null,
        zIndex: 99
    },
    content: {
        backgroundColor: 'rgba(255,255,255, 0.95)'
    },
    line: {
        backgroundColor: 'transparent',
        flexDirection: 'row',
        height: navigationPickerLineHeight,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: '10%'
    },
    activeLine: {
        backgroundColor: '#a4a4a4'
    },
    lineText: {
        color: '#383838',
        fontSize: 20,
        textAlign: 'left',
        fontFamily: Theme.regularFont
    },
    lineTextActive: {
        color: '#FFFFFF'
    },
    textContainer: {
        alignItems: 'center',
        justifyContent: 'center'
    }
};

if (Device.isTablet) {
    baseStyles.content = {
        width: 500,
        backgroundColor: 'rgba(255,255,255, 0.95)'
    };
    baseStyles.scrollViewContainer = {
        maxHeight: 330
    };
}

if (Device.isWeb) {
    baseStyles.content = {
        minWidth: 300,
        backgroundColor: 'rgba(255,255,255, 0.95)',
        marginTop: DETAIL_HEADER_HEIGHT,
        transition: 'margin .16s linear'
    };
    baseStyles.scrollViewContainer = {
        maxHeight: 330
    };
    baseStyles.pickerWindowFavSettings = {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        alignItems: 'center',
        zIndex: 99,
        margin: 'auto'
    };

    baseStyles.pickerWindow.width = '100%';
    baseStyles.pickerWindow.margin = 'auto';
    baseStyles.line = {
        ...baseStyles.line,
        paddingHorizontal: 10
    };
}

export default StyleSheet.create(baseStyles);
